import { mapThemeConfig } from "../render/mapThemes";
import type { MapTheme, TileKind, UnitKind } from "./types";
import { movementType, type MovementType } from "./units";

export interface TileDef {
  name: string;
  defensePercent: number;
  enterCost: Record<MovementType, number | null>;
}

const TILE_DEFS: Record<TileKind, TileDef> = {
  plain: {
    name: "Plains",
    defensePercent: 5,
    enterCost: { foot: 1, vehicle: 1, air: 1 },
  },
  forest: {
    name: "Forest",
    defensePercent: 10,
    enterCost: { foot: 1, vehicle: 2, air: 1 },
  },
  mountain: {
    name: "Mountain",
    defensePercent: 15,
    enterCost: { foot: 2, vehicle: null, air: 1 },
  },
  sea: {
    name: "Sea",
    defensePercent: 0,
    enterCost: { foot: null, vehicle: null, air: 1 },
  },
  road: {
    name: "Road",
    defensePercent: 0,
    enterCost: { foot: 1, vehicle: 1, air: 1 },
  },
  city: {
    name: "City",
    defensePercent: 20,
    enterCost: { foot: 1, vehicle: 1, air: 1 },
  },
  barracks: {
    name: "Barracks",
    defensePercent: 20,
    enterCost: { foot: 1, vehicle: 1, air: 1 },
  },
  factory: {
    name: "Factory",
    defensePercent: 20,
    enterCost: { foot: 1, vehicle: 1, air: 1 },
  },
  base: {
    name: "Base",
    defensePercent: 20,
    enterCost: { foot: 1, vehicle: 1, air: 1 },
  },
  airport: {
    name: "Airport",
    defensePercent: 20,
    enterCost: { foot: 1, vehicle: 1, air: 1 },
  },
  monument: {
    name: "Monument",
    defensePercent: 25,
    enterCost: { foot: 1, vehicle: 1, air: 1 },
  },
};

export function tileDef(kind: TileKind): TileDef {
  return TILE_DEFS[kind];
}

export function tileName({ kind, theme }: { kind: TileKind; theme?: MapTheme }): string {
  return mapThemeConfig(theme).tileNameOverrides[kind] ?? tileDef(kind).name;
}

export function terrainEnterableByUnit({
  unitKind,
  tileKind,
}: {
  unitKind: UnitKind;
  tileKind: TileKind;
}): boolean {
  return tileDef(tileKind).enterCost[movementType(unitKind)] !== null;
}
